import { bootstrapApplication } from '@angular/platform-browser';
import '../../libs/extensions/string-extensions';
import '../../libs/rxjs-imports';
import { AppTunnelComponent } from './app-tunnel.component';
import { appConfig } from './app.config';

bootstrapApplication(AppTunnelComponent, appConfig).catch((err) =>
  console.error(err),
);
